import { createRouter, createWebHistory } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import LoginPage from '@/views/LoginPage.vue'
import FlightAreasEmptyPage from '@/views/FlightAreasEmptyPage.vue'
import SettingsPage from '@/views/SettingsPage.vue'
import DroneInfoPage from '@/views/DroneInfoPage.vue'
import FlightAreasPage from '@/views/FlightAreasPage.vue'
import FlightRoutesPage from '@/views/FlightRoutesPage.vue'
import FlightRoutePointsPage from '@/views/FlightRoutePointsPage.vue'
import WeatherOverviewPage from '@/views/WeatherOverviewPage.vue'
import MapAndWeatherPage from '@/views/MapAndWeatherPage.vue'
import ObservationDataDisplayPage from '@/views/ObservationDataDisplayPage.vue'
import ErrorPage from '@/views/ErrorPage.vue'
import { useErrorStore } from '@/stores/error'
import { errorGuard } from './middlewares/errorGuard'
import { authGuard } from './middlewares/authGuard'
import { useFlightAreaStore } from '@/stores/flightArea'
import { useNoticeModalStore } from '@/stores/noticeModal'

const routes = [
  {
    path: '/',
    name: 'Login',
    component: LoginPage,
  },
  {
    path: '/error',
    name: 'ErrorPage',
    component: ErrorPage,
  },
  {
    path: '/',
    component: DefaultLayout,
    children: [
      {
        path: 'flight-area-empty',
        name: 'FlightAreasEmpty',
        component: FlightAreasEmptyPage,
        meta: {
          headerType: 'settings',
        },
      },
      {
        path: 'settings',
        name: 'Settings',
        component: SettingsPage,
        meta: {
          headerType: 'settings',
        },
      },
      {
        path: 'drone-info',
        name: 'DroneInfo',
        component: DroneInfoPage,
        meta: {
          headerType: 'settings',
        },
      },
      {
        path: 'flight-areas',
        name: 'FlightAreas',
        component: FlightAreasPage,
        meta: {
          headerType: 'settings',
        },
      },
      {
        path: 'flight-routes',
        name: 'FlightRoutesPage',
        component: FlightRoutesPage,
        meta: {
          headerType: 'settings',
        },
      },
      {
        path: 'flight-route-points/:areaId/:routeId',
        name: 'FlightRoutePointsPage',
        component: FlightRoutePointsPage,
        meta: {
          headerType: 'settings',
        },
      },
      {
        path: 'weather-over-view',
        name: 'WeatherOverviewPage',
        component: WeatherOverviewPage,
        meta: {
          headerType: 'contents',
        },
      },
      {
        path: 'map-and-weather',
        name: 'MapAndWeatherPage',
        component: MapAndWeatherPage,
        meta: {
          headerType: 'contents',
        },
      },
      {
        path: 'observation-data-display',
        name: 'ObservationDataDisplayPage',
        component: ObservationDataDisplayPage,
        meta: {
          headerType: 'contents',
        },
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

router.beforeEach(async (to, from, next) => {
  const errorStore = useErrorStore()

  // エラーがある場合は、ErrorPage 以外に遷移するときにクリア
  if (to.name !== 'ErrorPage') {
    errorStore.clearError()
  }

  // エラー有無チェック
  const errorTarget = errorGuard(to)
  if (errorTarget) {
    next(errorTarget)
    return
  }

  // 認証チェック
  const authTarget = await authGuard(to, from)
  if (authTarget) {
    next(authTarget)
    return
  }

  // 飛行エリア有無チェック
  // チェック対象外画面
  const passRoutes = ['Login', 'ErrorPage', 'FlightAreasEmpty', 'FlightAreas']
  const flightAreaStore = useFlightAreaStore()
  if (!passRoutes.includes(to.name as string)) {
    await flightAreaStore.fetchFlightAreas()
    if (!flightAreaStore || flightAreaStore.flightAreas.length === 0) {
      //飛行エリア設定確認画面に遷移
      next({ name: 'FlightAreasEmpty' })
      return
    }
  }

  // ご利用上の注意開閉
  const store = useNoticeModalStore()
  if (store.visible) {
    store.close()
  }

  next()
})

export default router
